import { defineComponent as _defineComponent } from 'vue'
import { HelperViewStatus } from '@warrenbrasil/nebraska-web';

interface Emits {
  (event: 'on-retry'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsViewError',
  emits: ["on-retry"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'on-retry'): void;
}), expose: any, slots: any, attrs: any }) {



return { __sfc: true,emits, HelperViewStatus }
}

})